import { render, staticRenderFns } from "./addRelatedAssets.vue?vue&type=template&id=972975d2"
import script from "./addRelatedAssets.vue?vue&type=script&lang=js"
export * from "./addRelatedAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports